module.exports = __webpack_public_path__ + "static/media/KMH_5264.35e2645b.jpg";